export const KEYS = {
  backspace: 8,
  comma: 188,
  downArrow: 40,
  enter: 13,
  esc: 27,
  space: 32,
  upArrow: 38,
  directPaste: 1786
};



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/angular2-tag-input/lib/shared/tag-input-keys.ts